import { Box } from '@factorialco/deprecated-design-system'
import { DataTableFilter, FilterType } from 'generated/resources/datatable.graphql'
import {
  ExpensesRateConfigurationFilter,
  LegalEntityForSelectFragment,
} from 'generated/resources/graphql'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import { LegalEntitySelector } from 'modules/core/components/LegalEntitySelector'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

const LegalEntityFilterComponent = () => {
  const { value, onValueChange } = useFilter<LegalEntityForSelectFragment[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <LegalEntitySelector
        width="s400"
        multiple
        hideBorder
        alwaysOpen
        label={''}
        value={value ?? []}
        onChange={onValueChange}
      />
    </Box>
  )
}

export const LegalEntityFilter = () => {
  const filter: DataTableFilter<ExpensesRateConfigurationFilter> = {
    type: FilterType.Entity,
    path: 'legalEntityIds',
    identifier: 'rateConfigurations.legalEntityFilter',
    title: i18n.t('expenses_v2.settings.rate_configurations.datatable.fields.legal_entity'),
    default: true,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'legalName',
        component: () => <LegalEntityFilterComponent />,
      },
    ],
  }
  return filter
}

export const CurrencyFilter = () => {
  const { company } = useCurrentSession()
  const validCurrencies = company.legalEntities.map((le) => le.currency).filter(Boolean)
  const uniqueCurrencies = [...new Set(validCurrencies)]
  const currencyOptions = uniqueCurrencies.map((currency) => ({
    value: currency,
    label: currency,
  }))
  const filter: DataTableFilter<ExpensesRateConfigurationFilter> = {
    type: FilterType.String,
    path: 'currency',
    identifier: 'rateConfigurations.currencyFilter',
    title: i18n.t('expenses_v2.settings.rate_configurations.datatable.fields.currency'),
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: currencyOptions,
      },
    ],
  }
  return filter
}

export const EmployeeFilter = () => {
  const filter: DataTableFilter<ExpensesRateConfigurationFilter> = {
    type: FilterType.Entity,
    path: 'employeeIds',
    identifier: 'rateConfigurations.employeeFilter',
    title: i18n.t('expenses_v2.settings.rate_configurations.datatable.fields.employee'),
    default: true,
    categories: [
      {
        kind: 'Employee',
        operation: 'in',
        nameAttribute: 'fullName',
      },
    ],
  }
  return filter
}
